import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AccountStateService {
  hasAccount = signal(false);
}
